<template>
    <!-- Spedizioni dei clienti viste da admin, SOLA LETTURA (05/10/2026).
         Nata per capire uno scarto di AS400 senza dover chiedere al cliente che cosa
         aveva scritto: qui si vede il modulo come l'ha compilato e il tracciato
         scomposto campo per campo, da confrontare con la lista errori di AS400. -->
    <div class="flex-1 min-w-0 p-2">
        <h2 class="mt-6 ml-4 font-semibold text-xl text-gray-800 leading-tight">
            {{ __('Spedizioni Clienti') }}
        </h2>

        <!-- 13/10/2026: avviso ai clienti in Crea Spedizioni (es. AS400 spento per manutenzione).
             Visibile se acceso E adesso e' fra inizio e fine (vuote = nessun limite). Al posto
             dei "30 secondi" nella finestra dopo la trasmissione compare questo testo. -->
        <div class="mx-3 mt-3 mb-1 p-3 rounded border text-xs"
            :class="avviso.visibile ? 'border-yellow-400 bg-yellow-50' : 'border-gray-300 bg-gray-50'">
            <div class="flex flex-wrap items-center mb-2">
                <span class="font-bold text-gray-800 mr-4">{{ __('Avviso ai clienti (Crea Spedizioni)') }}</span>
                <label class="inline-flex items-center mr-4 cursor-pointer">
                    <input type="checkbox" v-model="avviso.attivo" class="mr-1"> {{ __('acceso') }}
                </label>
                <span v-if="avviso.visibile" class="font-bold text-yellow-800">{{ __('i clienti lo vedono adesso') }}</span>
                <span v-else class="text-gray-500">{{ __('adesso i clienti non lo vedono') }}</span>
            </div>
            <div class="flex flex-wrap items-end">
                <div class="mr-3 mb-2 flex-1" style="min-width: 20rem">
                    <label class="block uppercase tracking-wide text-gray-700 font-bold mb-1">
                        {{ __('Testo') }} <span class="font-normal normal-case text-gray-500">({{ (avviso.testo || '').length }}/300)</span>
                    </label>
                    <textarea v-model="avviso.testo" maxlength="300" rows="2"
                        :placeholder="__('es. Oggi dalle 12:30 alle 14:30 etichette e lettere di vettura arriveranno in ritardo per manutenzione: le spedizioni trasmesse partono comunque.')"
                        class="w-full bg-white text-gray-700 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-gray-500"></textarea>
                </div>
                <div class="mr-3 mb-2">
                    <label class="block uppercase tracking-wide text-gray-700 font-bold mb-1">{{ __('Dalle') }}</label>
                    <input v-model="avviso.dal" type="datetime-local"
                        class="bg-white text-gray-700 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-gray-500">
                </div>
                <div class="mr-3 mb-2">
                    <label class="block uppercase tracking-wide text-gray-700 font-bold mb-1">{{ __('Alle') }}</label>
                    <input v-model="avviso.al" type="datetime-local"
                        class="bg-white text-gray-700 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-gray-500">
                </div>
                <div class="mb-2">
                    <button type="button" @click="salvaAvviso"
                        class="bg-red-600 hover:bg-red-800 text-white font-bold py-2 px-4 rounded">{{ __('salva avviso') }}</button>
                </div>
            </div>
            <div class="text-gray-500">{{ __('Inizio e fine vuoti: visibile finché è acceso. Il cliente lo vede quando apre o cambia scheda in Crea Spedizioni.') }}</div>
        </div>

        <form class="flex flex-wrap items-end px-3 my-3" @submit.prevent="carica(1)">
            <div class="mr-3 mb-2">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Cerca') }}</label>
                <input v-model="filtri.cerca" type="text" maxlength="40"
                    :placeholder="__('numero, rif. DDT, destinatario, cliente...')"
                    class="text-xs w-64 bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-2 focus:outline-none focus:bg-white focus:border-gray-500">
            </div>
            <div class="mr-3 mb-2">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Stato') }}</label>
                <select v-model="filtri.stato"
                    class="text-xs bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-2 focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">{{ __('tutti') }}</option>
                    <option v-for="s in stati" :key="s" :value="s">{{ s }}</option>
                </select>
            </div>
            <div class="mr-3 mb-2">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Creata dal') }}</label>
                <input v-model="filtri.dal" type="date"
                    class="text-xs bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-2 focus:outline-none focus:bg-white focus:border-gray-500">
            </div>
            <div class="mr-3 mb-2">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('al') }}</label>
                <input v-model="filtri.al" type="date"
                    class="text-xs bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-2 focus:outline-none focus:bg-white focus:border-gray-500">
            </div>
            <div class="mb-2">
                <button type="submit" class="bg-red-600 hover:bg-red-800 text-white text-xs font-bold py-2 px-4 rounded mr-2">
                    {{ __('cerca') }}
                </button>
                <button type="button" @click="pulisci" class="bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs font-bold py-2 px-4 rounded">
                    {{ __('pulisci') }}
                </button>
            </div>
        </form>

        <div class="w-full overflow-x-auto px-3">
            <table class="min-w-full text-xs">
                <thead>
                    <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                        <th class="px-2 py-2">{{ __('Numero') }}</th>
                        <th class="px-2 py-2">{{ __('Creata') }}</th>
                        <th class="px-2 py-2">{{ __('Trasmessa') }}</th>
                        <th class="px-2 py-2">{{ __('Stato') }}</th>
                        <th class="px-2 py-2">{{ __('Cliente') }}</th>
                        <th class="px-2 py-2">{{ __('Rif. DDT') }}</th>
                        <th class="px-2 py-2">{{ __('Destinatario') }}</th>
                        <th class="px-2 py-2">{{ __('Località') }}</th>
                        <th class="px-2 py-2">{{ __('Colli') }}</th>
                        <th class="px-2 py-2">{{ __('Peso') }}</th>
                        <th class="px-2 py-2">{{ __('Chiave AS400') }}</th>
                        <th class="px-2 py-2" :title="__('distinta di ritiro in cui è la spedizione')">{{ __('Distinta') }}</th>
                        <th class="px-2 py-2" :title="__('bancali a terra + sfusi')">{{ __('Etichette') }}</th>
                        <th class="px-2 py-2" :title="__('ultima stampa: foglio A4, oppure solo etichette singole')">{{ __('Stampa') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="r in righe" :key="r.id" @click="apri(r)"
                        class="border-b border-gray-200 cursor-pointer"
                        :class="aperta && aperta.richiesta.id === r.id ? 'bg-red-50' : 'hover:bg-gray-50'">
                        <td class="px-2 py-2 font-mono">{{ r.numeratore || '—' }}</td>
                        <td class="px-2 py-2 whitespace-nowrap">{{ dataOra(r.created_at) }}</td>
                        <td class="px-2 py-2 whitespace-nowrap">{{ dataOra(r.confermata_at) }}</td>
                        <td class="px-2 py-2"><span class="px-2 py-1 rounded font-bold" :class="coloreStato(r.stato)">{{ r.stato }}</span></td>
                        <td class="px-2 py-2">
                            <span class="font-mono">{{ r.cliente_filiale }}/{{ r.cliente_codice }}</span>
                            <span class="text-gray-600"> {{ r.cliente_ragsoc || r.utente_nome || r.utente_username }}</span>
                        </td>
                        <td class="px-2 py-2">{{ r.rif_ddt }}</td>
                        <td class="px-2 py-2">{{ r.dest_ragsoc }}</td>
                        <td class="px-2 py-2">{{ r.dest_cap }} {{ r.dest_localita }} ({{ r.dest_provincia }})</td>
                        <td class="px-2 py-2">{{ formatoIt(r.colli, 0) }}</td>
                        <td class="px-2 py-2">{{ formatoIt(r.peso_totale, 2) }}</td>
                        <td class="px-2 py-2 font-mono">{{ r.chiave_as400 || '' }}</td>
                        <td class="px-2 py-2 whitespace-nowrap">{{ r.distinta_numero || '—' }}</td>
                        <td class="px-2 py-2">{{ etichette(r) }}</td>
                        <td class="px-2 py-2 whitespace-nowrap">
                            <span v-if="r.stampa_a4_at" class="text-green-700" :title="dataOra(r.stampa_a4_at)">{{ __('A4') }}<span
                                v-if="r.stampa_a4_riempimento !== null && r.stampa_a4_riempimento !== undefined"
                                class="text-gray-700" :title="__('riempimento dei fogli dell\'ultima stampa A4 che la contiene')"> {{ r.stampa_a4_riempimento }}%</span></span>
                            <span v-else-if="r.stampa_eti_at" class="text-yellow-700" :title="dataOra(r.stampa_eti_at)">{{ __('singola') }}</span>
                            <span v-else class="text-gray-400">—</span>
                        </td>
                    </tr>
                    <tr v-if="righe.length === 0">
                        <td colspan="14" class="px-2 py-4 text-gray-500">{{ __('Nessuna spedizione.') }}</td>
                    </tr>
                </tbody>
                <!-- 09/10/2026: totali su tutte le righe del filtro, non solo su questa pagina -->
                <tfoot v-if="totali && Number(totali.spedizioni) > 0">
                    <tr class="border-t-2 border-gray-400 font-bold">
                        <td class="px-2 py-2" colspan="8">
                            {{ __('Totale') }}: {{ totali.spedizioni }} {{ __('spedizioni') }}
                            <span v-if="Number(totali.spedizioni) !== Number(totali.valide)" class="font-normal text-gray-600">
                                ({{ Number(totali.spedizioni) - Number(totali.valide) }} {{ __('annullate, fuori dai totali') }})
                            </span>
                        </td>
                        <td class="px-2 py-2">{{ formatoIt(totali.colli, 0) }}</td>
                        <td class="px-2 py-2">{{ formatoIt(totali.peso, 2) }}</td>
                        <td class="px-2 py-2"></td>
                        <td class="px-2 py-2"></td>
                        <td class="px-2 py-2">{{ formatoIt(totali.etichette, 0) }}</td>
                        <td class="px-2 py-2 whitespace-nowrap font-normal">
                            A4 {{ totali.stampate_a4 || 0 }} · {{ __('singola') }} {{ totali.stampate_singole || 0 }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <Paginator :paginator="paginator" @searchPage="cambiaPagina"></Paginator>

        <!-- 09/10/2026: stampe A4 delle etichette nel periodo (date "creata dal/al" = data
             della stampa). Vuoti = riquadri non usati: chi stampa una spedizione per volta spreca carta. -->
        <div v-if="stampe && stampe.totali" class="m-3 text-xs">
            <div class="font-bold text-gray-800 mb-1">
                {{ __('Stampe A4 delle etichette') }}:
                {{ stampe.totali.stampe }} {{ __('stampe') }},
                {{ formatoIt(stampe.totali.etichette, 0) }} {{ __('etichette') }},
                {{ formatoIt(stampe.totali.fogli, 0) }} {{ __('fogli') }},
                <span :class="Number(stampe.totali.vuoti) > 0 ? 'text-red-700' : ''">
                    {{ formatoIt(stampe.totali.vuoti, 0) }} {{ __('riquadri vuoti') }}
                </span>
                <span v-if="Number(stampe.totali.fogli) > 0">, {{ __('riempimento') }} {{ riempimento(stampe.totali) }}%</span>
            </div>
            <table v-if="stampe.righe && stampe.righe.length > 0" class="text-xs">
                <thead>
                    <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                        <th class="px-2 py-1">{{ __('Quando') }}</th>
                        <th class="px-2 py-1">{{ __('Cliente') }}</th>
                        <th class="px-2 py-1">{{ __('Spedizioni') }}</th>
                        <th class="px-2 py-1">{{ __('Etichette') }}</th>
                        <th class="px-2 py-1">{{ __('Fogli') }}</th>
                        <th class="px-2 py-1">{{ __('Vuoti') }}</th>
                        <th class="px-2 py-1">{{ __('Riempimento') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="st in stampe.righe" :key="st.id" class="border-b border-gray-200">
                        <td class="px-2 py-1 whitespace-nowrap">{{ dataOra(st.created_at) }}</td>
                        <td class="px-2 py-1">
                            <span class="font-mono">{{ st.filiale }}/{{ st.codice }}</span>
                            {{ st.cliente_ragsoc || st.utente_nome || st.utente_username }}
                        </td>
                        <td class="px-2 py-1">{{ st.spedizioni }}</td>
                        <td class="px-2 py-1">{{ st.etichette }}</td>
                        <td class="px-2 py-1">{{ st.fogli }}</td>
                        <td class="px-2 py-1" :class="Number(st.vuoti) > 0 ? 'text-red-700 font-bold' : ''">{{ st.vuoti }}</td>
                        <td class="px-2 py-1">{{ riempimento(st) }}%</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="stampe.righe && stampe.righe.length >= 50" class="text-gray-500 mt-1">{{ __('ultime 50 stampe: per le altre restringere le date') }}</div>
        </div>

        <!-- ======================================================= dettaglio === -->
        <div v-if="aperta" ref="dettaglio" class="m-3 p-4 border border-gray-300 rounded bg-white">
            <div class="flex flex-wrap items-center justify-between">
                <h3 class="font-semibold text-lg text-gray-800">
                    <span class="font-mono">{{ aperta.richiesta.numeratore || __('bozza senza numero') }}</span>
                    <span class="ml-2 px-2 py-1 rounded text-xs font-bold" :class="coloreStato(aperta.richiesta.stato)">{{ aperta.richiesta.stato }}</span>
                </h3>
                <button type="button" @click="aperta = null" class="text-gray-600 underline text-xs">{{ __('chiudi') }}</button>
            </div>
            <div class="text-xs text-gray-700 mt-1">
                {{ __('Cliente') }} <b class="font-mono">{{ aperta.richiesta.cliente_filiale }}/{{ aperta.richiesta.cliente_codice }}</b>
                <span v-if="aperta.utente"> — {{ aperta.utente.Nome }} ({{ aperta.utente.username }})</span>
                — {{ __('contratto') }} {{ aperta.richiesta.contratto }}
            </div>
            <div class="text-xs text-gray-600 mt-1">
                <span v-for="d in date" :key="d.campo" class="mr-4 whitespace-nowrap" v-show="aperta.richiesta[d.campo]">
                    {{ d.etichetta }}: <b>{{ dataOra(aperta.richiesta[d.campo]) }}</b>
                </span>
            </div>

            <!-- Il modulo come l'ha compilato il cliente: tutti i campi salvati, prima
                 quelli con un nome noto e poi gli altri, cosi' una colonna aggiunta in
                 futuro compare da sola invece di restare nascosta. -->
            <h4 class="mt-4 mb-1 uppercase text-xs font-bold text-gray-700">{{ __('Modulo del cliente') }}</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 text-xs">
                <div v-for="c in campiModulo" :key="c.chiave" class="flex border-b border-gray-100 py-1">
                    <span class="w-1/2 text-gray-600">{{ c.etichetta }}</span>
                    <span class="w-1/2 font-medium break-all">{{ c.valore }}</span>
                </div>
            </div>

            <h4 class="mt-4 mb-1 uppercase text-xs font-bold text-gray-700">{{ __('Colli') }}</h4>
            <table class="text-xs">
                <thead>
                    <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                        <th class="px-2 py-1">#</th>
                        <th class="px-2 py-1">{{ __('Lungh. cm') }}</th>
                        <th class="px-2 py-1">{{ __('Largh. cm') }}</th>
                        <th class="px-2 py-1">{{ __('Alt. cm') }}</th>
                        <th class="px-2 py-1">{{ __('Peso kg') }}</th>
                        <th class="px-2 py-1">{{ __('Cod. merce') }}</th>
                        <th class="px-2 py-1">{{ __('m³') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="b in aperta.richiesta.bancali" :key="b.id" class="border-b border-gray-100">
                        <td class="px-2 py-1">{{ b.progressivo }}</td>
                        <td class="px-2 py-1">{{ b.lunghezza_cm }}</td>
                        <td class="px-2 py-1">{{ b.larghezza_cm }}</td>
                        <td class="px-2 py-1">{{ b.altezza_cm }}</td>
                        <td class="px-2 py-1">{{ formatoIt(b.peso, 2) }}</td>
                        <td class="px-2 py-1 font-mono">{{ b.codice_merce }}</td>
                        <td class="px-2 py-1">{{ formatoIt(b.volume, 2) }}</td>
                    </tr>
                    <tr v-if="!aperta.richiesta.bancali || aperta.richiesta.bancali.length === 0">
                        <td colspan="7" class="px-2 py-1 text-gray-500">{{ __('nessun collo') }}</td>
                    </tr>
                </tbody>
            </table>

            <h4 class="mt-4 mb-1 uppercase text-xs font-bold text-gray-700">{{ __('Documenti arrivati') }}</h4>
            <div class="text-xs">
                <div v-for="d in aperta.richiesta.documenti" :key="d.id">
                    <b>{{ d.tipo }}</b> <span class="font-mono">{{ d.chiave_as400 }}</span> {{ d.file_name }} — {{ dataOra(d.arrivato_at) }}
                </div>
                <div v-if="!aperta.richiesta.documenti || aperta.richiesta.documenti.length === 0" class="text-gray-500">{{ __('nessuno') }}</div>
            </div>

            <!-- ================================================ tracciati === -->
            <div class="flex flex-wrap items-center justify-between mt-6">
                <h4 class="uppercase text-xs font-bold text-gray-700">{{ __('Tracciati verso AS400') }}</h4>
                <label class="text-xs text-gray-700 cursor-pointer">
                    <input type="checkbox" v-model="soloValorizzati" class="mr-1 align-middle">{{ __('solo i campi valorizzati') }}
                </label>
            </div>
            <div class="text-xs text-gray-500 italic mb-2">
                {{ __('Ricomposti adesso dai dati salvati, con lo stesso codice del job: se il programma è cambiato dopo la trasmissione, è ciò che partirebbe oggi.') }}
            </div>

            <div v-for="t in tracciati" :key="t.nome" class="mb-4">
                <div class="font-bold text-sm text-gray-800">{{ t.nome }} <span class="font-normal text-gray-600">— {{ t.titolo }}</span></div>
                <div v-if="t.dati.errore" class="p-2 my-1 rounded bg-red-100 text-red-800 text-xs">
                    {{ __('Il record non si compone:') }} {{ t.dati.errore }}
                </div>
                <div v-for="(rec, i) in t.dati.record" :key="i" class="mt-2">
                    <div class="text-xs text-gray-700">
                        <span v-if="t.dati.record.length > 1">{{ __('record') }} {{ i + 1 }} — </span>{{ rec.lunghezza }} byte
                    </div>
                    <pre class="text-xs bg-gray-100 p-2 overflow-x-auto whitespace-pre">{{ rec.grezzo }}</pre>
                    <div class="overflow-x-auto">
                        <table class="text-xs min-w-full">
                            <thead>
                                <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                                    <th class="px-2 py-1">{{ __('Campo') }}</th>
                                    <th class="px-2 py-1">{{ __('Descrizione') }}</th>
                                    <th class="px-2 py-1">{{ __('Pos.') }}</th>
                                    <th class="px-2 py-1">{{ __('Lung.') }}</th>
                                    <th class="px-2 py-1">{{ __('Tipo') }}</th>
                                    <th class="px-2 py-1">{{ __('Nel record') }}</th>
                                    <th class="px-2 py-1">{{ __('Valore') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="c in rec.campi" :key="c.campo" v-show="!soloValorizzati || !c.vuoto"
                                    class="border-b border-gray-100">
                                    <td class="px-2 py-1 font-mono">{{ c.campo }}</td>
                                    <td class="px-2 py-1 text-gray-600">{{ c.descrizione }}</td>
                                    <td class="px-2 py-1">{{ c.posizione }}</td>
                                    <td class="px-2 py-1">{{ c.lunghezza }}<span v-if="c.decimali > 0">,{{ c.decimali }}</span></td>
                                    <td class="px-2 py-1">{{ c.tipo }}</td>
                                    <!-- gli spazi diventano puntini: un allineamento sbagliato si vede subito -->
                                    <td class="px-2 py-1 font-mono whitespace-pre">{{ c.grezzo.replace(/ /g, '·') }}</td>
                                    <td class="px-2 py-1 font-medium">{{ c.valore }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Paginator from './utility/Paginator.vue';

/** Nomi leggibili dei campi di bol_richieste, nell'ordine in cui si mostrano. */
const ETICHETTE = {
    rif_ddt: 'Rif. DDT',
    dest_ragsoc: 'Destinatario',
    dest_ragsoc_ext: 'Destinatario (seguito)',
    dest_indirizzo: 'Indirizzo',
    dest_indirizzo_ext: 'Indirizzo (seguito)',
    dest_cap: 'CAP',
    dest_localita: 'Località',
    dest_provincia: 'Provincia',
    rif_destinatario: 'Rif. destinatario',
    avviso: 'Email avviso',
    dest_note: 'Note destinatario',
    segnacollo_mittente: 'Segnacollo mittente',
    colli: 'Colli',
    bancali_a_terra: 'Bancali a terra',
    epal: 'EPAL',
    non_epal: 'Non EPAL',
    sfusi: 'Sfusi',
    peso_sfusi: 'Peso sfusi',
    volume_sfusi: 'Volume sfusi',
    peso_totale: 'Peso totale',
    volume_totale: 'Volume totale',
    contrassegno: 'Contrassegno',
    tipo_incasso: 'Tipo incasso',
    note: 'Note',
    data_consegna: 'Data consegna',
    tipo_consegna: 'Tipo consegna',
    appuntamento: 'Prenotazione telefonica',
    giorno_chiusura: 'Giorno chiusura',
    test_chiusura: 'Chiusura (1 matt. 2 pom. 3 giorn.)',
    srv_facchinaggio: 'Facchinaggio',
    srv_piani: 'Consegna ai piani',
    srv_sponda: 'Sponda idraulica',
    srv_privati: 'Consegna a privati',
    srv_espresso: 'Consegna espressa',
    srv_merce_lunga: 'Merce lunga',
    srv_adr: 'ADR',
    srv_gdo: 'GDO',
    srv_ztl: 'ZTL',
};

/** Campi che non sono "il modulo": stanno gia' in testa al riquadro o sono interni. */
const NASCOSTI = ['id', 'user_id', 'cliente_filiale', 'cliente_codice', 'contratto', 'numeratore', 'stato',
    'bancali', 'documenti', 'utente_nome', 'utente_username', 'lease_fino_a',
    'created_at', 'updated_at', 'confermata_at', 'prelevata_at', 'inviata_at', 'ldv_at', 'eti_at',
    'allarme_at', 'annullata_at'];

export default {
    components: { Paginator },
    data() {
        return {
            filtri: { cerca: '', stato: '', dal: '', al: '' },
            stati: ['BOZZA', 'CONFERMATA', 'IN_INVIO', 'INVIATA', 'COMPLETA', 'ALLARME', 'ANNULLATA'],
            righe: [],
            paginator: {},
            totali: null,
            stampe: null,
            avviso: { attivo: false, testo: '', dal: '', al: '', visibile: false },
            aperta: null,
            soloValorizzati: true,
            date: [
                { campo: 'created_at', etichetta: 'creata' },
                { campo: 'confermata_at', etichetta: 'trasmessa' },
                { campo: 'prelevata_at', etichetta: 'prelevata dal job' },
                { campo: 'inviata_at', etichetta: 'inviata ad AS400' },
                { campo: 'ldv_at', etichetta: 'LDV' },
                { campo: 'eti_at', etichetta: 'etichette' },
                { campo: 'allarme_at', etichetta: 'allarme' },
                { campo: 'annullata_at', etichetta: 'annullata' },
            ],
        };
    },
    async created() {
        this.caricaAvviso();
        await this.carica(1);
    },
    computed: {
        campiModulo() {
            if (!this.aperta) return [];
            const r = this.aperta.richiesta;
            const noti = Object.keys(ETICHETTE).filter(k => k in r);
            const altri = Object.keys(r).filter(k => !(k in ETICHETTE) && !NASCOSTI.includes(k)).sort();
            return noti.concat(altri).map(k => ({
                chiave: k,
                etichetta: ETICHETTE[k] || k,
                valore: this.valoreModulo(r[k]),
            }));
        },
        tracciati() {
            if (!this.aperta) return [];
            return [
                { nome: 'NTDKTK', titolo: this.__('testata'), dati: this.aperta.testata || { errore: null, record: [] } },
                { nome: 'NTDKCO', titolo: this.__('dettaglio colli, un record per collo'), dati: this.aperta.dettaglio || { errore: null, record: [] } },
            ];
        },
    },
    methods: {
        valoreModulo(v) {
            if (v === true) return 'sì';
            if (v === false) return 'no';
            if (v === null || v === undefined || v === '') return '—';
            return String(v);
        },
        dataOra(v) {
            if (!v) return '—';
            const d = new Date(String(v).indexOf('T') > 0 ? v : String(v).replace(' ', 'T'));
            if (isNaN(d.getTime())) return String(v);
            const p = n => String(n).padStart(2, '0');
            return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear()
                + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
        },
        /** Etichette di una spedizione = bancali a terra + sfusi (Michele, 09/10/2026). */
        etichette(r) {
            return (Number(r.bancali_a_terra) || 0) + (Number(r.sfusi) || 0);
        },
        /** Riempimento % = etichette / (fogli x 4) (12/10/2026, prima c'era la % dei vuoti). */
        riempimento(t) {
            // 22/10/2026: occupati = riquadri - vuoti (un foglio ripreso da 2-4 non e' spreco);
            // sulle stampe di prima e' uguale a etichette / riquadri
            const riquadri = (Number(t.fogli) || 0) * 4;
            return riquadri > 0 ? Math.round((riquadri - (Number(t.vuoti) || 0)) * 100 / riquadri) : 0;
        },
        formatoIt(v, decimali) {
            const n = Number(v);
            if (v === null || v === undefined || isNaN(n)) return '';
            return n.toLocaleString('it-IT', { minimumFractionDigits: decimali, maximumFractionDigits: decimali });
        },
        coloreStato(stato) {
            switch (stato) {
                case 'BOZZA': return 'bg-gray-200 text-gray-700';
                case 'CONFERMATA': return 'bg-blue-100 text-blue-700';
                case 'IN_INVIO':
                case 'INVIATA': return 'bg-yellow-100 text-yellow-800';
                case 'COMPLETA': return 'bg-green-100 text-green-800';
                case 'ALLARME': return 'bg-red-200 text-red-800';
                case 'ANNULLATA': return 'bg-gray-300 text-gray-700 line-through';
                default: return 'bg-gray-200 text-gray-700';
            }
        },
        pulisci() {
            this.filtri = { cerca: '', stato: '', dal: '', al: '' };
            this.carica(1);
        },
        async carica(pagina = 1) {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post('/admin/bollettazione/lista', Object.assign({
                        risultati_pagina: 25,
                        page: pagina,
                    }, this.filtri)), false);
                if (res) {
                    const p = res.value ? res.value : res;
                    this.righe = p.data || [];
                    this.paginator = p;
                    this.totali = p.totali || null;
                    this.stampe = p.stampe || null;
                }
                return res;
            });
        },
        /** 13/10/2026: avviso ai clienti. */
        mettiAvviso(v) {
            if (!v) return;
            this.avviso = {
                attivo: !!v.attivo, testo: v.testo || '', dal: v.dal || '', al: v.al || '', visibile: !!v.visibile
            };
        },
        async caricaAvviso() {
            const res = await this.handleCallback(
                () => this.axios.post('/admin/bollettazione/avviso', {}), false);
            if (res) this.mettiAvviso(res.value ? res.value : res);
        },
        async salvaAvviso() {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post('/admin/bollettazione/avviso-salva', {
                        attivo: this.avviso.attivo, testo: this.avviso.testo,
                        dal: this.avviso.dal, al: this.avviso.al
                    }), false);
                if (res) {
                    this.mettiAvviso(res.value ? res.value : res);
                    this.$emit('notify', true, this.__('Avviso salvato'),
                        this.avviso.visibile ? this.__('i clienti lo vedono adesso') : this.__('adesso i clienti non lo vedono'));
                }
                return res;
            });
        },
        cambiaPagina(url) {
            if (!url) return;
            const m = /[?&]page=(\d+)/.exec(url);
            this.carica(m ? Number(m[1]) : 1);
        },
        async apri(r) {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post('/admin/bollettazione/dettaglio', { id: r.id }), false);
                if (res) {
                    this.aperta = res.value ? res.value : res;
                    this.$nextTick(() => {
                        if (this.$refs.dettaglio && this.$refs.dettaglio.scrollIntoView) {
                            this.$refs.dettaglio.scrollIntoView({ block: 'start', behavior: 'smooth' });
                        }
                    });
                }
                return res;
            });
        },
    },
};
</script>
